import React from 'react';
import { StarIcon } from 'lucide-react';
import { HeroAvatars } from './HeroAvatars';
import { mainGuide } from '../data/resources';
import { siteConfig } from '../data/siteConfig';
export function Hero() {
  const {
    trust,
    heroVideoUrl
  } = siteConfig;
  const rating = trust.rating;
  return <section className="bg-ivory px-5 sm:px-8 pt-8 pb-12 sm:pt-14 sm:pb-16 overflow-hidden" data-id="element-82" data-mp="4mi2n8mfxkdf">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-83" data-mp="12a0kd8y2xwtk">
        <p className="inline-flex items-center rounded-full border border-coral-deep/40 px-3 sm:px-4 py-1.5 text-xs font-semibold tracking-[0.04em] sm:tracking-[0.12em] whitespace-normal text-coral-deep" data-id="element-84" data-mp="xae5yw6imaj6">
          IMPRIMEZ · TRACEZ · PEIGNEZ · CRÉEZ
        </p>

        <h1 className="mt-5 font-serif text-[2.15rem] leading-[1.1] sm:text-5xl lg:text-[3.6rem] font-semibold text-teal text-balance" data-id="element-85" data-mp="nbyh6zuyndcu">
          Créez de jolies décorations en faux vitrail,{' '}
          <span className="italic font-medium text-coral-deep" data-id="element-86" data-mp="3814aznapvuna">à votre rythme.</span>
        </h1>

        <p className="mt-5 max-w-xl text-base sm:text-lg leading-relaxed text-ink/80" data-id="element-87" data-mp="3j9ainhg5sy79">
          Un guide pas à pas, des exercices pour débuter et plus de 100 modèles à
          imprimer pour tracer et peindre sur un support transparent.
        </p>

        {rating !== null && <div className="mt-6 inline-flex max-w-full items-center gap-3 rounded-2xl sm:rounded-full border border-gold/40 bg-ivory px-4 py-2.5 shadow-soft text-left" data-id="element-88" data-mp="3e8egb8bghk3y">
            <HeroAvatars data-id="element-89" data-mp="358hmksa7lv21" />
            <span className="flex flex-col sm:flex-row sm:items-center gap-x-2 gap-y-0.5" data-id="element-90" data-mp="359t0vm1a6l7e">
              <span className="flex items-center gap-2" data-id="element-91" data-mp="2qkmthasahoof">
                <span className="flex gap-0.5 text-gold" role="img" aria-label={`Note moyenne ${rating.toLocaleString('fr-FR')} sur 5`} data-id="element-92" data-mp="2qi0jz5lu8z3k">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} size={14} aria-hidden="true" className="fill-current" data-id="element-93" data-mp="2lkqyg11kl7l0" data-mpi={i} />)}
                </span>
                <span className="text-sm font-semibold text-ink whitespace-nowrap" data-id="element-94" data-mp="s2jmpvqkdyiz">
                  {rating.toLocaleString('fr-FR')} / 5
                </span>
              </span>
              <span className="text-sm text-ink/80" data-id="element-95" data-mp="ic86patlvyvq">
                <span aria-hidden="true" className="hidden sm:inline" data-id="element-96" data-mp="iczzyezqdkiu">· </span>
                {trust.customerLabel}
              </span>
            </span>
          </div>}

        <div className="relative mt-9 w-full max-w-[340px] sm:max-w-[400px]" data-id="element-97" data-mp="1b1fcmuve3qr0">
          <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem] border-[6px] border-white bg-sand shadow-frame ring-1 ring-coral/30" data-id="element-98" data-mp="161t06nndyej9">
            {heroVideoUrl ? <video src={heroVideoUrl} autoPlay muted loop playsInline controls={false} disablePictureInPicture preload="auto" className="h-full w-full object-cover" data-id="element-99" data-mp="110wq1scfxw5e" /> : <img src={mainGuide.image} alt={mainGuide.imageAlt} decoding="async" className="h-full w-full object-cover" data-id="element-100" data-mp="3lt756pxsnptq" />}

            <span className="pointer-events-none absolute left-3 top-3 rounded-full bg-ivory/95 px-3 py-1.5 text-xs font-semibold text-teal shadow-soft" data-id="element-101" data-mp="3hqk6q66mb6nk">
              Guide + 5 bonus
            </span>
            {!heroVideoUrl && <span aria-hidden="true" className="pointer-events-none absolute bottom-3 right-3 flex h-[84px] w-[84px] flex-col items-center justify-center rounded-full bg-coral-deep text-white shadow-soft ring-4 ring-white/70" data-id="element-102" data-mp="218tntq0zt0c8">
                <span className="font-serif text-2xl font-bold leading-none" data-id="element-103" data-mp="2g02kgj3bblyv">100+</span>
                <span className="mt-0.5 text-xs font-semibold" data-id="element-104" data-mp="2kyvnfhkz3uks">modèles</span>
              </span>}
          </div>
          {heroVideoUrl && <span aria-hidden="true" className="pointer-events-none absolute -top-3 right-3 flex h-[76px] w-[76px] flex-col items-center justify-center rounded-full bg-coral-deep text-white shadow-soft ring-4 ring-ivory" data-id="element-105" data-mp="2p08utw3ps5tt">
              <span className="font-serif text-xl font-bold leading-none" data-id="element-106" data-mp="unrcn2xqfvw1">100+</span>
              <span className="mt-0.5 text-xs font-semibold" data-id="element-107" data-mp="zmluo2nvlgf3">modèles</span>
            </span>}
        </div>

        <a href="#offre" className="mt-9 inline-flex min-h-[52px] w-full sm:w-auto items-center justify-center whitespace-normal rounded-full bg-coral-deep px-4 sm:px-9 py-4 text-base font-semibold text-white shadow-soft transition-colors duration-200 hover:bg-coral-darker" data-id="element-108" data-mp="4aco3i0njza2">
          Je découvre le pack — {siteConfig.price}
        </a>
        <p className="mt-3.5 text-sm text-ink/70" data-id="element-109" data-mp="98e2hpn4vaf7">
          Paiement unique · Produit numérique · Matériel non inclus
        </p>
      </div>
    </section>;
}